import RenderString from '../RenderString';
import moment from 'moment';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ConfirmModal } from './ConfirmModal';
import { useState } from 'react';

export const PreviousNoteCard = ({ note, handleNoteEdit, handleNoteDelete }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  let title = note.title;
  if (!title) {
    const cleaned = note.content?.replace(/(<([^>]+)>)/gi, '');
    let first20 = cleaned.substring(0, 20);
    if (first20.length === 20) {
      first20 += '...';
    }
    title = first20;
  }
  const date = moment(note.createdAt).calendar();

  const editNote = () => {
    handleNoteEdit(note);
  };

  const deleteNoteModal = () => {
    setShowConfirmModal(true);
  };

  const deleteNote = () => {
    handleNoteDelete(note);
    setShowConfirmModal(false);
  };

  return (
    <div className="flex flex-col rounded-[10px] border border-gray-300 bg-white p-4">
      <span className="text-base leading-tight font-bold tracking-wide text-gray-500 uppercase">{date}</span>
      <div className="flex justify-between">
        <div className="font-['Montserrat'] text-2xl leading-loose font-black text-gray-900">{title}</div>
        <div className="flex h-3 items-center gap-2">
          <PencilSquareIcon className="size-8 hover:cursor-pointer" onClick={editNote}></PencilSquareIcon>
          <TrashIcon className="size-8 hover:cursor-pointer" onClick={deleteNoteModal}></TrashIcon>
        </div>
      </div>
      <RenderString className="w-full pl-2 break-all whitespace-pre-wrap" content={note.content} />
      {showConfirmModal && (
        <ConfirmModal
          title="Confirm"
          content="Are you sure you want to delete this note?"
          onConfirm={() => deleteNote()}
          onClose={() => setShowConfirmModal(false)}
        ></ConfirmModal>
      )}
    </div>
  );
};